import request from '@/utils/request'

let Courseware_categoryApi = {

  /*课件分类列表*/
  list(data) {
    return request._post('/shop/plus.courseware_category.Index/index', data);
},
/*添加课件分类*/
add(data) {
    return request._post('/shop/plus.courseware_category.Index/add', data);
},
/*修改课件分类*/
edit(data) {
    return request._post('/shop/plus.courseware_category.Index/edit', data);
},
/*删除课件分类*/
del(data) {
    return request._post('/shop/plus.courseware_category.Index/del', data);
},
/*课件分类详情*/
detail(data) {
  return request._post('/shop/plus.courseware_category.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.courseware_category.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.courseware_category.Setting/getSetting', data, errorback);
    },
}
export default Courseware_categoryApi;



// WEBPACK FOOTER //
// ./src/api/courseware_category.js